import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, Events } from 'ionic-angular';
import { ApiService } from '../../api-service/api-service';

import { UserFeedback } from '../../providers/providers';

//import {AdFooter} from '../ad-footer/ad-footer';


@Component({
  templateUrl: 'post-feedback.html'
})
export class PostFeedbackPage {
  message = "";
  type = "Comment";

  //public adFooter = AdFooter;

  
  constructor(public server:ApiService, 
    public navCtrl: NavController,
    public navParams:NavParams,
    public loadingCtrl: LoadingController,
    public events:Events) {
      
  }
  cancel(){
      this.navCtrl.pop();
  }

  sendFeedback(){
    let feedback = new UserFeedback();
    feedback.Message = this.message;
    feedback.Type = this.type;
    this.server.postFeedback(feedback,this.sendFeedbackCallback);
    //this.server.postPic(this.userPost, this.postPicCallback);
  }

  //Fat arrow used to keep scope, private entry back in
  public sendFeedbackCallback = (comments) => {
    this.backToLadder();
  }

  backToLadder(){
    alert('Thank you for your feedback!');
    this.navCtrl.pop();
  }
  

}


// WEBPACK FOOTER //
// ./src/pages/post-feedback/post-feedback.ts